import { api } from './client';

export type PromptType =
  | 'CLASSIFICATION'
  | 'REFINEMENT_USER_STORY'
  | 'REFINEMENT_BUG';

export type PromptTemplate = {
  type: PromptType;
  content: string;
  updatedAt: string;
  updatedBy?: string | null;
};

export async function listPrompts(): Promise<PromptTemplate[]> {
  const { data } = await api.get<PromptTemplate[]>('/admin/prompts');
  return data;
}

export async function updatePrompt(type: PromptType, content: string): Promise<PromptTemplate> {
  const { data } = await api.put<PromptTemplate>(`/admin/prompts/${type}`, { content });
  return data;
}
